import React, { useState, useEffect } from "react";
import useRequireAuth from "../../utils/useRequireAuth";
import { useDispatch } from "react-redux";
import { useLazyFetchPersonAllInOrgQuery } from "../../utils/customer/customerTable";
import OwnerDropDown from "../GlobalFeature/Fields/OwnerDropDown";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import { pushAlert } from "../../utils/alertSlice";
import BasicSelect from "../Task/BasicSelect";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import Button from "../UniversalComponents/DefaultButton";
import { fetchManagePermission, grantPermission } from "../../utils/api/managePermissionApi";
import { getCompanyId } from "../../utils/utilityFunctions/localServices";
import SelectComponent from "../UniversalComponents/SelectComponent";

const EditGroupMember = ({ isOpen, onClose, group_id, selectedMember, setIsApiLoading, onSuccessSubmit }) => {
  const token = useRequireAuth();
  const dispatch = useDispatch();
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);
  const [message, setMessage] = useState(null);
  const [errors, setErrors] = useState({});
  const [groupTableData, setGroupTableData] = useState([]);

  const [formData, setFormData] = useState({
    email: selectedMember?.group_member_email,
    userId: selectedMember?.group_member_id,
    ownerType: selectedMember?.owner === 1 ? "owner" : "contributor",
  });

  const handlePersonData = (value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      email: value?.email,
      userId: value?.id,
    }));
  };

  const optionListowner = [
    {
      label: "contributor",
      value: "0",
    },
    {
      label: "owner",
      value: "1",
    },
  ];

  const handleFieldChange = (e) => {
    const { name, value } = e.target;

    const selectedOption = optionListowner.find((option) => option.value === value);

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: selectedOption ? selectedOption?.label : value,
    }));
  };

  const validate = () => {
    let tempErrors = {};

    if (!formData?.email) {
      tempErrors.email = "Please Select Email from List";
    }
    if (!formData?.ownerType) {
      tempErrors.ownerType = "access is required";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSave = async (event) => {
    event.preventDefault();
    setIsApiLoading(true);
    if (!validate()) {
      return false;
    }

    const ownerTypeId = optionListowner?.filter((item) => item.label === formData?.ownerType)[0].value;

    const body = {
      company_id: getCompanyId(),
      owner: ownerTypeId,
      group_id: group_id,
      group_member_id: formData.userId,
    };

    try {
      const response = await grantPermission({ body });
      if (response?.success) {
        onClose();
        setMessage(response?.message);
        dispatch(pushAlert({ message: response?.message, type: "success", visible: true }));
        onSuccessSubmit();
      } else {
        dispatch(pushAlert({ message: "response?.message", type: "danger", visible: true }));
        setMessage(response?.message);
      }
    } catch (error) {
      dispatch(
        pushAlert({
          message: error?.response?.data?.message || "An error occurred while submitting the form.",
          type: "danger",
          visible: true,
        })
      );
      dispatch(pushAlert({ message: error?.message, type: "danger", visible: true }));
    }

    setIsApiLoading(false);
  };

  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonAllInOrgQuery();

  const fetchPersonData = async (data) => {
    await fetchPersonInTable({ token: token?.token, data: data, companyId: parsedCompanyData?.company_id });
  };

  const tableDetail = {
    tableidclass: "taskmodelowner",
  };

  const handleInsert = () => {};

  setTimeout(() => {
    setMessage(null);
  }, 5000);

  return (
    <CustomDrawer open={isOpen} onClose={onClose}>
      <div className="z-[999] h-full  bg-white border font-popins overflow-hidden flex flex-col">
        <div className=" flex items-center justify-between py-3 px-6 border-b border-BECBD3">
          <h3 className="text-lg font-500 text-434852 ">
            {selectedMember?.group_member_id ? "Update" : "Create"} Group Member
          </h3>

          <button
            onClick={onClose}
            type="button"
            className="text-454545  hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
            data-modal-hide="assets-modal"
          >
            <CloseModalImg className="w-3 h-3" />
            <span className="sr-only">Close modal</span>
          </button>
        </div>

        <form onSubmit={handleSave} className="flex flex-col flex-grow overflow-auto  pt-2">
          <div className="px-6">
            <div className="">
              <label htmlFor="chart_of_accounts_id" className="block pb-1 text-base text-434852 pt-2">
                Email <span className=" text-red-500 "> *</span>
                {errors && <span className="text-red-700 text-sm"> {errors?.email}</span>}
              </label>

              <OwnerDropDown
                tableidclass={tableDetail.tableidclass}
                fetchPersonInTable={fetchPersonData}
                DropData={personTableData?.data}
                handleInsert={handleInsert}
                handlePersonData={handlePersonData}
                owner={formData?.email}
              />
            </div>

            <div className="pt-3">
              <label htmlFor="Designation" className="block pb-1 text-base text-434852">
                Access <span className=" text-red-500 "> *</span>
                {errors && <span className="text-red-700 text-sm"> {errors?.ownerType}</span>}
              </label>
              <BasicSelect
                options={optionListowner || []}
                place
                name="ownerType"
                selectedOptions={optionListowner?.filter((option) => option?.label === formData["ownerType"])}
                onChange={handleFieldChange}
                onClick={() => {}}
                type={"select"}
                size={"medium"}
                label="owner"
              />
            </div>

            <div className="pt-3">
              <label htmlFor="Designation" className="block pb-1 text-base text-434852">
                Access <span className=" text-red-500 "> *</span>
                {errors && <span className="text-red-700 text-sm"> {errors?.ownerType}</span>}
              </label>
              <BasicSelect
                options={optionListowner || []}
                place
                name="ownerType"
                selectedOptions={optionListowner?.filter((option) => option?.label === formData["ownerType"])}
                onChange={handleFieldChange}
                onClick={() => {}}
                type={"select"}
                size={"medium"}
                label="owner"
              />
            </div>
          </div>
          <div className="sticky bottom-0 bg-white py-4 pr-3 flex justify-end text-md w-full border-t border-DFE2E5 mt-auto">
            {message && <p className="text-green-500 text-right	">{message}</p>}
            <div className="px-2 gap-3 flex">
              <Button variant={"secondary"} onClick={onClose}>
                CANCEL
              </Button>
              <Button variant={"primary"} type={"submit"}>
                SAVE
              </Button>
            </div>
          </div>
        </form>
      </div>
    </CustomDrawer>
  );
};

export default EditGroupMember;
